// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Size } from 'models/propTypes/tile';

import Image from 'components/common/Image';

import { getImageUrl } from 'support/imageHelper';
import equalizerImage from 'assets/images/equalizer.webp';

import styles from './MediaView.module.scss';

const getWidthFromSize = size => {
  switch (size) {
    case 'sm':
      return 303;
    case 'md':
      return 390;
    case 'lg':
    default:
      return 478;
  }
};

const MediaView = ({
  src: originalSrc,
  size,
  isNowPlaying,
  renderMetadata,
  autoSizeSrc,
  hasFocus,
  isHighlights,
  className,
  isDvr,
}) => {
  const src = autoSizeSrc
    ? getImageUrl(originalSrc, getWidthFromSize(size))
    : originalSrc;
  return (
    <div
      className={classNames('w-100', 'position-relative', styles[`${size}_h`])}
      data-testid="media-view"
    >
      <Image
        alt="media view background"
        src={src}
        className={classNames('w-100', 'h-100', styles.image, className)}
        data-testid="background-image"
      />
      <div
        className={classNames(
          'w-100',
          'h-100',
          styles.imageOverlay,
          isDvr ? styles.dvrBackground : styles.nonDvrBackground,
        )}
      />
      {renderMetadata && (
        <div className={styles.metadata}>{renderMetadata(hasFocus)}</div>
      )}
      {isNowPlaying && (
        <div
          className={classNames(styles.nowPlaying)}
          data-testid="now-playing-badge"
        >
          <img
            alt="equalizer"
            src={equalizerImage}
            className={
              isHighlights ? styles.equalizerForHighlights : styles.equalizer
            }
          />
        </div>
      )}
    </div>
  );
};

MediaView.propTypes = {
  src: PropTypes.string.isRequired,
  size: Size.isRequired,
  isNowPlaying: PropTypes.bool,
  renderMetadata: PropTypes.func,
  autoSizeSrc: PropTypes.bool, // Tells the mediatile that it's receiving a configurable image source that it should size
  hasFocus: PropTypes.bool,
  isHighlights: PropTypes.bool,
  className: PropTypes.string,
  isDvr: PropTypes.bool,
};

MediaView.defaultProps = {
  isNowPlaying: false,
  renderMetadata: null,
  autoSizeSrc: true,
  hasFocus: false,
  isHighlights: false,
  className: null,
  isDvr: false,
};

export default MediaView;
